
// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyCrFdQVH0MrryatK2eDY19Yf_1YON31wvg",
  authDomain: "trider-c3efc.firebaseapp.com",
  projectId: "trider-c3efc",
  storageBucket: "trider-c3efc.appspot.com",
  messagingSenderId: "936885140370",
  appId: "1:936885140370:web:b2c7f38a1bb992c1075f4b",
  measurementId: "G-H3MXRCQ0LT",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Export messaging only if supported
let messaging = null;

isSupported()
  .then((supported) => {
    if (supported) {
      messaging = getMessaging(firebaseApp);
      console.log("✅ Firebase Messaging initialized:", messaging);
    } else {
      console.warn("⚠️ Firebase Messaging not supported in this browser.");
    }
  })
  .catch((err) => {
    console.error("❌ Error checking messaging support:", err);
  });

export { firebaseApp, messaging }; 
